<script>
export default {
  name: "UsersCreateForm",
  props: {
    onformsubmit: {
      type: Function,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // add this for change input type
      fieldTypes: {
        password: "text",
        password2: "text",
      },
    };
  },
  methods: {
    handleType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if (type === "blur" && !value) {
        this.fieldTypes[name] = "text";
      } else {
        this.fieldTypes[name] = "password";
      }
    },
  },
};
</script>
<template>
  <b-form id="form" @submit="onformsubmit">
    <form-wrapper :validator="validator">
      <div>
        <form-summary />
      </div>
      <form-group name="username" :label="$t('username')">
        <b-form-input
          v-model="form.username"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
          value=""
        />
      </form-group>
      <form-group name="email" :label="$t('email')">
        <b-form-input
          v-model="form.email"
          :id="Math.random()"
          type="text"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          v-bind="attrs"
          v-on="listeners"
          value=""
        />
      </form-group>
      <form-group name="password" :label="$t('password')">
        <b-form-input
          v-model="form.password"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          :type="fieldTypes.password"
          @focus="handleType"
          @blur="handleType"
          name="password"
          value=""
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
      <form-group name="repeat_password" :label="$t('repeat_password')">
        <b-form-input
          v-model="form.repeat_password"
          autocomplete="off"
          slot-scope="{ attrs, listeners }"
          :type="fieldTypes.password2"
          @focus="handleType"
          @blur="handleType"
          name="password2"
          value=""
          v-bind="attrs"
          v-on="listeners"
        />
      </form-group>
    </form-wrapper>
  </b-form>
</template>
